import { styled } from '@mui/material/styles';
import { shouldForwardProp } from '@mui/system';
import LoadingButton from '../LoadingButton/LoadingButton';

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    !['buttonColor', 'textColor'].includes(prop as string);

export const StyledButton = styled(LoadingButton, {
    shouldForwardProp: customShouldForwardProp,
})<{ buttonColor?: string; textColor?: string }>(
    ({ buttonColor, textColor, theme }) => ({
        color: textColor ?? buttonColor ?? theme.palette.common.white,
        borderColor: textColor ?? buttonColor ?? theme.palette.common.white,
        borderRadius: '50px',
    })
);
